import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  referenceId: PropTypes.string,
  name: PropTypes.string,
});
